import { createBrowserRouter, createHashRouter } from 'react-router'
import { lazy } from 'react'
import { RootLayout } from '@/layouts/RootLayout'
import { AppLayout } from '@/layouts/AppLayout'

const HomePage = lazy(() => import('@/pages/Home'))
const HomeV2Page = lazy(() => import('@/pages/HomeV2'))
const HomeV3Page = lazy(() => import('@/pages/HomeV3'))
const WorkflowPage = lazy(() => import('@/pages/Workflow'))
const SettingsPage = lazy(() => import('@/pages/Settings'))
const GeneratePage = lazy(() => import('@/pages/Generate'))
const KitPage = lazy(() => import('@/pages/Kit'))
const BlueprintsGlobalPage = lazy(() => import('@/pages/BlueprintsGlobal'))
const BlueprintsMine = lazy(() => import('@/pages/BlueprintsMine'))
const PresetsPage = lazy(() => import('@/pages/Presets'))
const AppsHomePage = lazy(() => import('@/pages/AppsHome'))

const routes = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: (
      <div style={{ padding: '2rem', color: '#f4f4f5', background: '#09090b' }}>
        Something went wrong.
      </div>
    ),
    children: [
      { index: true, element: <HomeV3Page /> },
      { path: 'v1', element: <HomePage /> },
      { path: 'v2', element: <HomeV2Page /> },
      { path: 'kit', element: <KitPage /> },
      {
        path: 'apps',
        element: <AppLayout />,
        children: [
          { index: true, element: <AppsHomePage /> },
          {
            path: ':provider',
            children: [
              { path: 'generate-images', element: <GeneratePage /> },
              { path: 'generate-videos', element: <GeneratePage /> },
              { path: 'generate-actors', element: <GeneratePage /> },
              { path: 'generate-image-to-video', element: <GeneratePage /> },
              { path: 'character', element: <GeneratePage /> },
            ],
          },
          { path: 'blueprint', element: <WorkflowPage /> },
          { path: 'blueprint/:blueprintId', element: <WorkflowPage /> },
          { path: 'blueprints/global', element: <BlueprintsGlobalPage /> },
          { path: 'blueprints/mine', element: <BlueprintsMine /> },
          { path: 'presets', element: <PresetsPage /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
]

const isTauri = typeof window !== 'undefined' && '__TAURI__' in window
export const router = isTauri ? createHashRouter(routes) : createBrowserRouter(routes)
